






































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

import CouponList from "@/components/searchMember/couponList.vue";
import stepBar from "@/components/searchMember/stepBar.vue";

const searchMemberModule = namespace("searchMember");

@Component({
  components: {
    CouponList,
    stepBar
  }
})
export default class SearchMember extends Vue {
  @searchMemberModule.State("memberDetail") memberDetail!: any;
  active: number = 2;
  memberKeyword: any = "";
  pageNum: number = 1;
  pageSize: number = 10;
  loading: boolean = false;
  finished: boolean = false;
  total: number = 0;
  couponAvailableList: any = [];
  singleDetail: any = {};
  step: number = 0;
  writeSessionId: any = "";
  writeOffTime: any = "";
  created() {
    this.memberKeyword = this.$route.query.memberKeyword;
  }
  mounted() {
    if (JSON.stringify(this.memberDetail) === "{}") {
      //防止刷新详情丢失
      this.onSearchMobile();
    }
    this.$store.commit("coupon/setcouponSearchStep", 2);
  }
  onSearchMobile() {
    if (!this.memberKeyword) {
      this.navigateTo(`/couponVerification/searchMember`);
      return;
    }
    this.$store
      .dispatch("searchMember/memberDetail", {
        searchText: this.memberKeyword,
        searchType: 1
      })
      .then(({ success, error }) => {
        error && this.onSearchCardNo();
      });
  }
  onSearchCardNo() {
    this.$store
      .dispatch("searchMember/memberDetail", {
        searchText: this.memberKeyword,
        searchType: 3
      })
      .then(({ success, error }) => {
        if (success) {
          this.navigateTo(`/couponVerification/searchMember`);
        }
      });
  }
  getCouponAvailableList() {
    let self = this;
    this.$store
      .dispatch("searchMember/dispatchCouponAvailableList", {
        couponInstanceCid: self.memberDetail.memberCid,
        couponInstanceStatus: 2,
        couponBusinessEntityId: this.$global.tenantId,
        upBusinessEntityId: this.$global.parentBusinessEntityId,
        pageNum: self.pageNum,
        pageSize: self.pageSize,
        notInCouponCategoryId: [10]
      })
      .then(({ success, error }) => {
        self.loading = false;
        if (success) {
          let data = success.data;
          self.total = data.total;
          if (self.pageNum >= data.pages) {
            self.finished = true;
          }
          self.pageNum = self.pageNum + 1;
          // debugger;
          const _list =
            data.list &&
            data.list.map((item: any) => {
              let _item = item;
              _item.couponEffectiveDateFmt = [
                [
                  self.$format(_item.couponEffectiveStartTime),
                  self.$format(_item.couponEffectiveEndTime)
                ].join("至"),
                _item.couponActivedLimitedStartDay == 0 &&
                _item.couponActivedLimitedDays == 1
                  ? "仅当天有效"
                  : (_item.couponActivedLimitedStartDay == 0
                      ? "领取后当天开始(含当天)有效"
                      : "领取后" +
                        (_item.couponActivedLimitedStartDay + 1 > 0
                          ? "第" +
                            (_item.couponActivedLimitedStartDay + 1) +
                            "天开始(含当天)有效"
                          : "当天开始有效")) +
                    ", 有效期" +
                    _item.couponActivedLimitedDays +
                    "天",
                [
                  self.$format(_item.couponGetStartTime),
                  self.$format(_item.couponGetEndTime)
                ].join("至")
              ][_item.couponEffectiveSwitch];
              console.log(_item.couponEffectiveDateFmt);
              console.log(_item.couponEffectiveSwitch);
              // _item.couponEffectiveStartTime = self.$format(   [_item.couponEffectiveSwitch]
              //   _item.couponEffectiveStartTime,
              //   "YYYY.MM.DD"
              // );
              // _item.couponEffectiveEndTime = self.$format(
              //   _item.couponEffectiveEndTime,
              //   "YYYY.MM.DD"
              // );
              return _item;
            });
          console.log(_list);
          self.couponAvailableList = [...self.couponAvailableList, ..._list];
        }
      });
  }
  onLoadList() {
    this.getCouponAvailableList();
  }
  confirmCancel() {
    (this as any).$dialog
      .confirm({
        title: "确认核销",
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        cancelButtonColor: "#1989fa",
        message: "券码：" + this.singleDetail.couponInstanceQrCode
      })
      .then((res: any) => {
        console.log(res);
        if (res == "confirm") {
          this.$store
            .dispatch("searchMember/dispatchCouponDetail", {
              couponInstanceQrCode: this.singleDetail.couponInstanceQrCode,
              couponInstanceFlowWriteoffChannel:
                this.singleDetail.writeOffChannel || "商户通",
              operationType: 1,
              writeSessionId: this.writeSessionId
            })
            .then(({ success, error }) => {
              if (success) {
                this.writeOffTime = success.data.writeOffTime;
              }
            });
        } else {
          console.log("cancel");
        }
      })
      .catch((res: any) => {});
  }
  navigateTo(path: string, query: object = {}) {
    if (!path) {
      return (this as any).$toast("无此路径");
    }
    this.$router.push({
      path,
      query: { ...query }
    });
  }
  toast(message: string = "") {
    return (this as any).$toast({ message });
  }
}
